import { ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SegmentedControlGroupStyled = styled(ToggleButtonGroup)(
  ({ theme, fullWidth }) => ({
    backgroundColor: theme.palette.gray[100],
    borderRadius: theme.spacing(1.25),
    width: fullWidth ? '100%' : 'fit-content',
    maxWidth: '100%',
    padding: theme.spacing(0.5),
    gap: theme.spacing(0.5),
    flexWrap: 'nowrap',
    // keep horizontal scroll for overflow (mainly touch/mobile swipe) but hide the scrollbar
    overflowX: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.black[850],
    }),

    '& .MuiToggleButton-root': {
      border: 'none',
      borderRadius: theme.spacing(0.75),
      margin: 0,
      padding: theme.spacing(1, 1.5),
      minWidth: 'unset',
      flexShrink: 0,
      // Split the track into equal segments when the control is full-width.
      ...(fullWidth && { flex: '1 1 0' }),
      whiteSpace: 'nowrap',
      lineHeight: 1.2,
      textTransform: 'none',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 500,
      color: theme.palette.gray[500],
      transition: 'background 0.15s, color 0.15s',
      ...theme.applyStyles('dark', {
        color: theme.palette.black[200],
      }),

      '&:not(:first-of-type)': {
        borderTopLeftRadius: theme.spacing(0.75),
        borderBottomLeftRadius: theme.spacing(0.75),
      },

      '&:not(:last-of-type)': {
        borderTopRightRadius: theme.spacing(0.75),
        borderBottomRightRadius: theme.spacing(0.75),
      },

      '&:hover': {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.black[700],
        ...theme.applyStyles('dark', {
          backgroundColor: theme.palette.grayTrue[850],
          color: theme.palette.black[100],
        }),
      },

      '&.Mui-selected': {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.black[700],
        fontWeight: 500,
        boxShadow:
          '0px 1px 2px -1px rgba(10, 13, 18, 0.1), 0px 1px 3px 0px rgba(10, 13, 18, 0.1)',
        ...theme.applyStyles('dark', {
          backgroundColor: theme.palette.grayTrue[850],
          color: theme.palette.black[100],
        }),

        '&:hover': {
          backgroundColor: theme.palette.common.white,
          ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grayTrue[850],
          }),
        },
      },
    },
  }),
);
